export const faqItems = [
  {
    question: "久久插产品的防护等级是什么意思？如何选择？",
    answer: "防护等级（IP 等级）由两位数字组成，第一位表示防尘等级（0-6），第二位表示防水等级（0-9）。久久插产品覆盖 IP65 至 IP68。一般室内环境选择 IP20-IP44，户外环境建议 IP65 以上，水下应用需选择 IP67 或 IP68。如有疑问，可联系久久插技术团队获取专业建议。",
  },
  {
    question: "久久插插接器的使用寿命有多长？",
    answer: "久久插工业级插接器的机械插拔寿命可达 5000-10000 次，在正常使用条件下可使用 10 年以上。实际寿命受使用环境、负载情况和维护保养等因素影响。久久插建议定期进行外观检查和清洁保养，以延长产品使用寿命。",
  },
  {
    question: "久久插提供定制插接方案吗？流程是怎样的？",
    answer: "是的，久久插提供专业的定制插接解决方案。流程包括：需求沟通 → 方案设计（含 3D 模型）→ 快速打样（7-15 个工作日）→ 小批量验证 → 量产交付。久久插已为 50 多家企业提供定制服务，涵盖新能源、医疗设备等领域。",
  },
  {
    question: "久久插产品有哪些认证？",
    answer: "久久插产品已通过多项国内外权威认证，包括中国 CCC 认证、欧盟 CE 认证、美国 UL 认证等。久久插生产体系通过 ISO 9001 质量管理体系认证，所有产品均符合 RoHS 环保标准。",
  },
  {
    question: "如何购买久久插产品？售后服务如何？",
    answer: "久久插产品可通过官方商城、授权经销商及主流电商平台购买。所有产品均享受至少 2 年质保，工业级产品提供 5 年质保。久久插设有专业的售后技术团队，提供 7×24 小时在线支持。如遇任何产品问题，可拨打久久插客服热线 400-888-XXXX。",
  },
  {
    question: "久久插的防水插接器能在水下使用吗？",
    answer: "久久插 WP-002 水下专用插接器支持最深 50 米潜水深度，采用 316 不锈钢外壳和双重密封结构，具备优异的耐海水腐蚀性能。久久插 WP-001 系列（IP68）可用于浅水浸泡场景。请在使用前确认产品的具体潜水深度限制。",
  },
  {
    question: "久久插智能插座支持哪些智能家居平台？",
    answer: "久久插 HH-003 智能插座支持主流智能音箱语音控制，可通过久久插 APP 实现远程开关、定时任务和电量统计。产品兼容 2.4GHz WiFi 网络，无需额外网关设备。",
  },
];